import { Component } from '@angular/core';
import { SignUpService } from './sign-up.service';


@Component({
  selector: 'app-sign-up',
  standalone: false,
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.css'
})
export class SignUpComponent {

  name: string = '';
  email: string = '';
  password: string = '';
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    private _signUpService: SignUpService
  ) { }

  async onSubmit() {
    this.errorMessage = '';
    this.successMessage = '';

    try {
      await this._signUpService.signUp(this.name, this.email, this.password);
      this.successMessage = 'Conta criada. Confirme seu e-mail e depois entre para configurar o autenticador.';
    } catch (error) {
      this.errorMessage = error instanceof Error ? error.message : 'Não foi possível criar a conta.';
    }
  }
}
